import React, { useEffect, useState } from 'react'
import { setValue, setCurrentId } from '../../Contexts/InputOutputHandler'
import { useCurrentSubView, useValues } from '../../../hooks/external'

import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'
import { CurrentSubView } from '../../../models/enums'

interface CheckboxAsButtonProps {
  id: string
  choices: any
}

const CheckboxAsButton = ({ id, choices }: CheckboxAsButtonProps): JSX.Element => {
  const currentSubView = useCurrentSubView()
  const values = useValues()
  const [display, setDisplay] = useState<Array<any>>([])
  const [chosen, setChosen] = useState<Array<string>>((values.get(id) as Array<string>) || [])

  useEffect(() => {
    currentSubView !== CurrentSubView.history && setCurrentId(id)
  }, [])

  /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */
  useEffect(() => {
    choices && setDisplay(choices)
  }, [choices])

  /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */
  useEffect(() => {
    setValue(id, chosen)
  }, [chosen])

  /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */
  const handleChange = (value: string): void => {
    if (currentSubView !== CurrentSubView.history) {
      let tempChosen = [...chosen]
      if (tempChosen.includes(value)) {
        tempChosen = tempChosen.filter((chosenValue) => chosenValue !== value)
      } else {
        tempChosen = [...tempChosen, value]
      }
      setChosen(tempChosen)
    }
  }

  return display && display.length > 0 ? (
    <div className='rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto'>
      {display.map((choice, key) => {
        return (
          <label
            key={key}
            className={`rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${
              chosen.includes(choice.value)
                ? 'rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover'
                : 'rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault'
            } rf-mb-4 hover:rf-cursor-pointer`}
          >
            <input type='checkbox' value={choice.value} checked={chosen.includes(choice.value)} className='rf-input-hidden' onChange={(): void => handleChange(choice.value)} />
            {capitalizeFirstLetter(choice.title)}
          </label>
        )
      })}
    </div>
  ) : (
    <React.Fragment />
  )
}

export default CheckboxAsButton
